import { useState } from "react";
import Modal from "react-modal";
import "./css/Modais.css";
import "./css/ModaisMobile.css";
import "./css/Images.css";
import check from './images/check.svg'
import ButtonX from "../Images/ButtonX.svg"
import Toast from '../Toast/Toast';

export default function ModalA({ isOpen, onRequestClose, calculo, mensalidade,consumoMinimo, mediaFinal }) {

  const [list] = useState([]);

  function numberPoint(numero) {
    // eslint-disable-next-line
    var numero = numero.toFixed(2).split('.');
    numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.');
    return numero.join(',');
  }

  function formatarNumero(numero) {
    // Converte o número para string, caso não seja
    let numeroString = numero.toString();

    // Separa a parte inteira da parte decimal (se houver)
    let partes = numeroString.split('.');
    let parteInteira = partes[0];
    let parteDecimal = partes.length > 1 ? '.' + partes[1] : '';

    // Formata a parte inteira adicionando pontos a cada três dígitos
    let parteInteiraFormatada = parteInteira.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Retorna o número formatado
    return parteInteiraFormatada + parteDecimal;
}
  return (
    <>
      <Toast toastList={list} autoDelete={true} />
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel="Modal"
        style={{ outline: 0 }}
        ariaHideApp={false}
        className={{
          base: "modal-base",
          afterOpen: "modal-base_after-open",
          beforeClose: "modal-base_before-close"
        }}
        overlayClassName={{
          base: "overlay-base",
          afterOpen: "overlay-base_after-open",
          beforeClose: "overlay-base_before-close"
        }}
        shouldCloseOnOverlayClick={true}
      >
          <div className="imgX" id="btnXModalGPCR" onClick={onRequestClose}><img alt={""} src={ButtonX}></img></div>
          <img className="imgCheck" alt={""} src={check}></img>
          <div className="modalTitle">Simulação de proposta</div>
          <br />
          <div className="modalSubTitle">A <b>economia anual prevista</b> para esse valor será de R$ {numberPoint(Number(calculo))}</div>
          <br />
          <div className="modalSubTitle">O valor estimado da <b>mensalidade</b> será de R$ {numberPoint(Number(mensalidade))}</div>
          <br />
          <div className="modalSubTitle"><b>Geração anual prevista</b>: {formatarNumero(Number(consumoMinimo))} kWh</div>
          <br />
          <div className="modalSubTitle"><b>Consumo médio previsto</b>: {formatarNumero(Number(mediaFinal))} kWh</div>
          <br />
      </Modal>
    </>
  )
}
